// import { jsPDF } from "jspdf";

// Default export is a4 paper, portrait, using millimeters for units

class Pdf{
  constructor(api, axios, helper){
    this.API    = api;
    this.axios  = axios;
    this.helper = helper;
    this.DOC    = null;
    
    // Lazy loading for jsPDF to prevent memory consumption until needed
    this.jsPDF = null;
    this.pdfLoaded = false;
  }
  
  // Lazy load jsPDF only when needed
  async loadPDF() {
    if (!this.pdfLoaded) {
      try {
        const { jsPDF } = await import('jspdf');
        this.jsPDF = jsPDF;
        this.pdfLoaded = true;
        console.log('jsPDF loaded successfully');
      } catch (error) {
        console.error('Error loading jsPDF:', error);
        throw error;
      }
    }
    return this.jsPDF;
  }
  
  download_pdf(){
    // This method will be updated to use lazy loading
    console.warn('download_pdf should be called with async version');
  }
  
  async download_pdf_async(){
    const jsPDF = await this.loadPDF();
    const doc = new jsPDF();
    /*
    let c = 0
    for (var i = 0; i < 100; i++) {
      
      if (c == 29) {
        doc.addPage()
        c = 0;
      }
      doc.text("Hello world!" + i , 10, c * 10);
      c ++;
    }*/
    doc.save("a4.pdf");
  }
  
  // Additional PDF methods can be added here with async versions
  async create_pdf_async(content = "Hello World") {
    const jsPDF = await this.loadPDF();
    const doc = new jsPDF();
    doc.text(content, 10, 10);
    return doc;
  }
  
  async save_pdf_async(doc, filename = "document.pdf") {
    if (doc) {
      doc.save(filename);
    }
  }
}

export default Pdf;